import { ProductType } from '@headless-workspace/typings';

export const getVariantImageShapeClassName = (type: ProductType, squaredShade: boolean): string => {
    const isShadeType = type === ProductType.MULTI_SKU_SHADE_UNI || type === ProductType.MULTI_SKU_SHADE_DIFF;

    // The case where the VipBrands configuration requests a square shape
    if (squaredShade) {
        return 'rounded-none';
    }

    if (
        isShadeType ||
        // FIXME: Waiting for size or shade information on mono_sku to handle specific cases
        type === ProductType.MONO_SKU
    ) {
        return 'rounded-infinity';
    }

    return 'rounded-0.25';
};

export const getVariantImageClassNames = (
    type: ProductType,
    squaredShade: boolean,
): {
    imageClassName: string;
    shapeClassName: string;
} => {
    const imageClassName = 'w-variantImage h-variantImage';
    const shapeClassName = getVariantImageShapeClassName(type, squaredShade);

    return {
        imageClassName,
        shapeClassName,
    };
};
